var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #33211a;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_data"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,7.7H4c-1.4,0-2.5,1.1-2.5,2.5v34.6c0,1.4,1.1,2.5,2.5,2.5h42.1c1.4,0,2.5-1.1,2.5-2.5V10.2c0-1.4-1.1-2.5-2.5-2.5h-3.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.1,
    y1: 2.7,
    x2: 15.1,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.9,
    y1: 2.7,
    x2: 34.9,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.5,
    y1: 7.7,
    x2: 34.9,
    y2: 7.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.6,
    y1: 20.1,
    x2: 41.1,
    y2: 20.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 20.1,
    x2: 11.4,
    y2: 20.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.8,
    y1: 20.1,
    x2: 21.3,
    y2: 20.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.7,
    y1: 20.1,
    x2: 31.2,
    y2: 20.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.6,
    y1: 27.5,
    x2: 41.1,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 27.5,
    x2: 11.4,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.8,
    y1: 27.5,
    x2: 21.3,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.7,
    y1: 27.5,
    x2: 31.2,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.9,
    y1: 34.9,
    x2: 11.4,
    y2: 34.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.8,
    y1: 34.9,
    x2: 21.3,
    y2: 34.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.7,
    y1: 34.9,
    x2: 31.2,
    y2: 34.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.e8c50d6694626ac6fdfb4c02f710a460.svg";
export { ForwardRef as ReactComponent };